import React, { useEffect } from 'react';
import _isEmpty from 'lodash/isEmpty';
import { useDispatch, useSelector } from 'react-redux';
import { List, ListItem, ListItemText } from '@material-ui/core';
import SideBarListStyles from '../../styles/SideBarListStyle';
import {
  setRockedFuelSelectedCategory,
  setRockedFuelSelectedSubCategory,
  setRockedFuelSidebar,
  showProgress,
} from '../../redux/actions/DealershipActions';
import Service from '../../apis/service';
import { ErrorToast } from '../utils/Utils';
import ShowProgress from '../ui/Backdrop';
import { apiEndpoints } from '../../constants/apiEndpoints';

export default function SidebarListFuel({ filterArray }) {
  const classes = SideBarListStyles();
  const dispatch = useDispatch();
  const categorySelected = useSelector((state) => state.rockedFuelData.selectedCategory);

  const fetchSidebarList = async () => {
    dispatch(showProgress(true));

    try {
      const res = await Service.get(apiEndpoints.FUEL_CATEGORIES);
      dispatch(setRockedFuelSidebar(res));
      if (!_isEmpty(res)) {
        handleListItemClick(res[0]);
      }
    } catch (error) {
      ErrorToast(error);
    }
  };

  useEffect(() => {
    fetchSidebarList();
  }, []);

  const handleListItemClick = async (user = {}) => {
    dispatch(showProgress(true));
    if (!_isEmpty(user)) {
      dispatch(setRockedFuelSelectedCategory(user));
    }
    dispatch(showProgress(false));
  };

  useEffect(() => {
    if (!_isEmpty(categorySelected)) {
      const fiteSubCategory = categorySelected?.fuelSubCategories;
      dispatch(setRockedFuelSelectedSubCategory(fiteSubCategory.length > 0 ? fiteSubCategory[0] : []));
    }
  }, [categorySelected]);

  return (
    <div className={classes.root}>
      <List component="nav" aria-label="secondary mailbox folder">
        {filterArray?.map((data) => (
          <div key={data.id} className={categorySelected.id === data.id ? classes.highlightItem : ''}>
            <ListItem
              id={`Item${data.id}`}
              key={data.id}
              button
              selected={categorySelected.id === data.id}
              className={classes.listStyling}
              onClick={() => handleListItemClick(data)}
            >
              <ListItemText
                primary={
                  <div>
                    <p
                      className={`${
                        categorySelected.id === data.id ? classes.listTextSelected : classes.listTextNonSelected
                      }`}
                    >
                      {data.title}
                    </p>
                  </div>
                }
              />
            </ListItem>
          </div>
        ))}
      </List>
      <ShowProgress />
    </div>
  );
}
